import ServiceBase from '../../ServiceBase';
import summaryProxy from '../../../proxies/market/watchlist/SummaryProxy';

class SummaryService extends ServiceBase {
  getWatchListSummary(params, source) {
    return this.processSubscription(data => this.extractTickerChannels(data))(
      () =>
        this.getData(() => summaryProxy.getWatchListSummary(params, source)),
    );
  }

  getWatchListDerivative(params, source) {
    return this.processSubscription(data => {
      var res = [];

      for (var deri of data.items) {
        res.push(this.getSubscribtionChannel(deri.derivativeCode));
      }

      return res;
    })(() =>
      this.applyMemoryCache('SummaryService.getDerivatives', params)(() =>
        summaryProxy.getWatchListDerivative(params, source),
      ),
    );
  }

  getBonds(params, source) {
    return this.processSubscription(data => {
      var res = [];

      for (var deri of data.items) {
        res.push(this.getSubscribtionChannel(deri.derivativeCode));
      }

      return res;
    })(() =>
      this.applyMemoryCache('SummaryService.getBonds', params)(() =>
        summaryProxy.getBonds(params, source),
      ),
    );
  }

  getWatchListPutThrough(params, source) {
    return this.processSubscription(data => {
      var res = [];

      for (var ticker of data.items[0].hose) {
        res.push(this.getSubscribtionChannel(ticker.organCode));
      }

      for (var ticker of data.items[0].hnx) {
        res.push(this.getSubscribtionChannel(ticker.organCode));
      }

      for (var ticker of data.items[0].upcom) {
        res.push(this.getSubscribtionChannel(ticker.organCode));
      }

      return res;
    })(() =>
      this.applyMemoryCache('SummaryService.getWatchListPutThrough', params)(
        () => summaryProxy.getWatchListPutThrough(params, source),
      ),
    );
  }

  getTwoDaysSeries(params, source) {
    return this.applyMemoryCache(
      'SummaryService.getPerformanceChartData',
      params,
    )(() => summaryProxy.getTwoDaysSeries(params, source));
  }

  getTickerSummary(params, source) {
    return this.applyMemoryCache('SummaryService.getTickerSummary', params)(
      () => summaryProxy.getTickerSummary(params, source),
    );
  }
}

const summaryService = new SummaryService();
export default summaryService;
